import { initializeApp as initialize } from 'firebase/app';
import {  getFirestore as getFireStore2 } from 'firebase/firestore';
import {getStorage} from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBbJZsigATPlV7E47Dp23Uz9f7iJJwpKRw",
    authDomain: "farmaturn-f1f63.firebaseapp.com",
    projectId: "farmaturn-f1f63",
    storageBucket: "farmaturn-f1f63.appspot.com",
    messagingSenderId: "619456540484",
    appId: "1:619456540484:web:fc35d9096acf9c558f3111"
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig);

// export const database = getFirestore()





// TODO: Replace the following with your app's Firebase project configuration


export const app = initialize(firebaseConfig);
export const db = getFireStore2(app)
export const storage = getStorage(app, 'gs://farmaturn-f1f63.appspot.com');


// import firebase from "firebase/compat/app"
// import "firebase/compat/auth"
// import "firebase/compat/firestore"
// import "firebase/compat/storage"
//
// if(!firebase.apps.length){
//     firebase.initializeApp(firebaseConfig)
// }
//
// export {firebase}
